const ENV = process.env.NODE_ENV === "development" ? "dev" : process.env.NODE_ENV === "production" ? "prod" : "test"
export default ENV